import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import {
	customMatchFunc,
	Loader,
} from "../ticketModule/variables/ListingVariables";
import overlayFactory from "react-bootstrap-table2-overlay";
import { Pager } from "../../components/Pager";

export const MyOfficeTable = (props) => {
	const {
		items,
		columns,
		tableStyle,
		paginationProps,
		paginationTableProps,
		onTablePageChange,
		tableLoader,
		inputValue,
		defaultSorted,
		keyField,
		pagerData,
		headerClass,
	} = props;

	//Function to handle Next page
	const handleNextPage = () => {
		if (paginationProps.page === paginationProps.paginationSize) return;
		paginationProps.onPageChange(paginationProps.page + 1);
		if (pagerData) onTablePageChange(paginationProps.page + 1, "right");
		else onTablePageChange(paginationProps.page + 1);
	};

	//Function to handle previous page
	const handlePrevPage = () => {
		if (paginationProps.page === 1) return;
		paginationProps.onPageChange(paginationProps.page - 1);
		if (pagerData) onTablePageChange(paginationProps.page - 1, "left");
		else onTablePageChange(paginationProps.page - 1);
	};

	return (
		<div>
			<ToolkitProvider
				bootstrap4
				keyField={keyField}
				data={items}
				columns={columns}
				search={{ customMatchFunc, searchFormatted: true }}
			>
				{(props) => {
					return (
						<div className="officeHoursTableContainer container-fluid p-0 fbList">
							<BootstrapTable
								remote
								onTableChange={onTablePageChange}
								classes="table-sm table-borderless"
								hover
								rowStyle={tableStyle}
								headerClasses={
									headerClass ? headerClass : "header-class"
								}
								bodyClasses={"tableBody"}
								bordered={false}
								{...props.baseProps}
								defaultSorted={defaultSorted}
								defaultSortDirection="asc"
								noDataIndication={() =>
									tableLoader ? (
										<Loader />
									) : (
										<div
											className="font-weight-bold mt-4"
											style={{
												color: "black",
												textAlign: "center",
											}}
										>
											<span>NO RECORD FOUND</span>
										</div>
									)
								}
								{...paginationTableProps}
								loading={tableLoader ? tableLoader : false}
								overlay={overlayFactory({
									spinner: true,
									color: "secondary",
									styles: {
										overlay: (base) => ({
											...base,
											background: "rgba(0,0,0,0.1)",
										}),
									},
								})}
							/>
						</div>
					);
				}}
			</ToolkitProvider>

			{/*--------- Show pagination Component if there is pager data ---------*/}
			{pagerData ? (
				<Pager
					receiveData={(pageNumber, PageSize) => {
						props.receiveData(pageNumber, PageSize);
					}}
					pager={pagerData}
					onPaginateLeft={handlePrevPage}
					onPaginateRight={handleNextPage}
				/>
			) : paginationProps ? (
				inputValue === "" && (
					<div className="d-flex justify-content-end" role="group">
						<button
							className="btn prevPg btn-sm mr-2"
							disabled={paginationProps.page === 1 ? true : false}
							onClick={handlePrevPage}
						>
							Prev
						</button>
						<button
							className="btn nextPg btn-sm"
							disabled={
								paginationProps.page ===
								paginationProps.paginationSize
									? true
									: false
							}
							onClick={handleNextPage}
						>
							Next
						</button>
					</div>
				)
			) : null}
		</div>
	);
};
